import { useSession } from '@cfs-fixings/shared'
import { Outlet, useNavigate } from 'react-router-dom'
import { AuthenticatedLayout } from '@cfs-fixings/shared'
import { useGetAuthSessionQuery } from '@/api/serverApi'

function ProtectedRouteTemplate () {
  const navigate = useNavigate()

  useSession({
    getData: useGetAuthSessionQuery,
    onNoSession: () => {
      navigate('/')
    },
  })

  return (
    <AuthenticatedLayout>
      <Outlet />
    </AuthenticatedLayout>
  )
}

export default ProtectedRouteTemplate
